import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import './addShippingAddress.css'

import { IoMdCloseCircle } from "react-icons/io";

export default function AddShippingAddress({ onClose, children }) {
 
   return (
     <div className="modal-background" onClick={onClose}>
       <div className="modal-content" onClick={(e) => e.stopPropagation()}>
         <button className="modal-close" onClick={onClose}><IoMdCloseCircle color='firebrick' size={25}/></button>
         {children}
       </div>
     </div>
   );
 }
